// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  Timesheet State
// -------------------------------
export interface TimesheetState extends EntityState<any> {
  common?: any;
  form?: Array<any>;
}

// -------------------------------
//  Timesheet Adapter
// -------------------------------
export const TimesheetAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Timesheet Initial State
// -------------------------------
export const initialState: TimesheetState = TimesheetAdapter.getInitialState(
  {
    common: null,
    form: [],
  },
);
